export const constructQueryForTerms = (type, terms, teksti) => {
  const query = `
    query RezultatiQuery($lang: String!, $page: Int, $perpage: Int, $orderby: [String], $order: [String], $search: String, $from: Int, $to: Int, ${terms.map(term => `$${term}: [String]`).join(', ')}) {
      ${type}(lang: $lang, page: $page, perpage: $perpage, orderby: $orderby, order: $order, search: $search, from: $from, to: $to, ${terms.map(term => `${term}: $${term}`).join(', ')}) {
        page
        perpage
        total
        ${constructTermsPartial(terms, ['slug', 'name', 'count'])}
        posts {
          _id
          path
          title
          date_created
          date_modified
          acf
          ${constructTermsPartial(terms, ['slug', 'name'])}
        }
      }
      ${constructTekstiPartial(teksti)}
    }
  `;
  return query;
};

export const constructQueryForPostTerms = (terms, teksti) => {
  const query = `
    query PostQuery($lang: String!, $postId: [Int]!) {
      page(lang: $lang, _id: $postId) {
        path
        date_created
        date_modified
        title
        content
        acf
        ${constructTermsPartial(terms)}
      }
      ${constructTekstiPartial(teksti)}
    }
  `;

  return query;
};

export const constructTermsPartial = (terms, keys = ['name']) => {
  if (terms && Array.isArray(terms) && terms.length > 0) {
    return `
      terms {
        ${terms.map(term => `
        ${term} {
          ${keys.map(key => key).join('\n')}
        }
      `).join('')}
      }
    `;
  }
  return ``;
}

export const constructTekstiPartial = (teksti) => {
  if (teksti && Array.isArray(teksti) && teksti.length > 0) {
    return `
      teksti(lang: $lang, _id: [${teksti.map(id => `"${id}"`).join(', ')}]) {
        _id
        text
      }
    `;
  }
  return ``;
}

export const constructTermsObj = (terms, data = null) => {
  const obj = {};
  terms.forEach(term => {
    obj[term] = (data && data[term]) ? data[term] : null;
  });
  return obj;
};



// WEBPACK FOOTER //
// ./src/utils/constructQuery.js